import { render } from "./ErrorTooltip.vue?vue&type=template&id=30856d11"
import script from "./ErrorTooltip.vue?vue&type=script&lang=js"
export * from "./ErrorTooltip.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__